/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BreedCreateDto } from '../../models/breed-create-dto';
import { BreedDto } from '../../models/breed-dto';

export interface BreedControllerCreate$Params {
      body: BreedCreateDto
}

export function breedControllerCreate(http: HttpClient, rootUrl: string, params: BreedControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BreedDto>> {
  const rb = new RequestBuilder(rootUrl, breedControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BreedDto>;
    })
  );
}

breedControllerCreate.PATH = '/api/breed';
